/**
 * B Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Error message response
 */
export interface ErrorMessage {
  code?: number;
  message?: string;
}
